import React,{useState} from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
  IconButton,
  Skeleton,
  Modal,
  Typography,
  Grid,
  Chip
} from "@mui/material";
import { RowData } from "../../pages/dashboard/flexiTermLoan/Withdraw";
import InfoIcon from "./../../assets/images/icons/info.png";
import Eye from "./../../assets/images/icons/eye.png";
import { formatNormalDate, formatDate } from "../../utils/dateFormatUtils";
import { formatNormalIndianRupees } from "../../utils/formatting";
import ModalViewAction from "./ModalViewAction";
// import { currencyIcon } from "../../data/constant";
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

interface Column {
  id: string;
  label: string;
  format?: (value: any) => string;
}

interface TablesProps {
  columns: Column[];
  rows: RowData[];
  rowsone?: RowData[];
  page: number;
  rowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isLoading: boolean;
  totalRecords: number;
  onActionClick?: (row: RowData) => void;
}

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  background: "rgba(255, 255, 255, 0.6)",
  boxShadow: "0px 4px 18px rgba(0, 0, 0, 0.07)",
  borderRadius: "6px",
}));

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  padding: "2px",
  color: "#168794",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "19px",
  textTransform: "capitalize",
  fontFamily: "Jost",
  textAlign: "left",
  height: "45px",
  width: "200px",
  "&:first-of-type": { paddingLeft: "10px" },
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
  padding: "2px",
  color: "#707579",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "22px",
  textAlign: "left",
  width: "200px",
  "&:first-of-type": { paddingLeft: "10px" },
}));

const StatusBadge = styled("span")<{
  statusColor: string;
  backgroundColor: string;
}>(({ statusColor, backgroundColor }) => ({
  color: statusColor,
  textTransform: "capitalize",
  backgroundColor,
  // display: "block",
  textAlign: "left",
  width: "110px",
  padding: "4px 1px",
  borderRadius: "4px",
  fontSize: "14px",
  fontWeight: 500,
  border: "none",
  display: "inline-block",
}));

// const formatDate = (isoDateString: string) => {
//   const date = new Date(isoDateString);
//   const day = date.getDate().toString().padStart(2, "0");
//   const month = (date.getMonth() + 1).toString().padStart(2, "0");
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
// };

const displayValue = (
  column: Column,
  row: RowData,
  onActionClick?: (row: RowData) => void
) => {
  const value = row[column.id];
  if (column.id === "view_status") {
    return column.format ? column.format(row?.requestId) : value;
  } else if ((value === "" || value === undefined || Number.isNaN(value)) && column.label!="Action") {
    return "-";
  }

  if (!column.id.trim()) {
    return "-";
  }
  if (column?.id === "amountPaid" || column?.id === "totalAmount") {
    return formatNormalIndianRupees(value);
  }
  if (column.format && typeof value === "number") {
    return column.format(value);
  }

  if (
    column.id === "transactionDate" ||
    column.id === "transcationDate" ||
    column.id === "requestedDate" ||
    column.id === "disbursemntDate" ||
    (column.id === "created_at" && typeof value === "string")
  ) {
    if (value === "-" || (typeof value === "string" && value.trim() === "")) {
      return "-";
    }
    return formatDate(value as string);
  } else if (column.id === "requestAt") {
    return formatNormalDate(value as string);
  }

  if (column.label === "Action" && onActionClick) {
    return (
      <>
        <IconButton onClick={() => onActionClick(row)}>
          <img src={Eye} />
        </IconButton>
      </>
    );
  }

  return value !== null ? String(value) : "-";
};

// const handleCurrencyIcon = (currencyCode: any) => {
//   const currency = currencyIcon.find((currency) => currency.currencyCode === currencyCode);
//   return currency?.icon;
// }

const Tables: React.FC<TablesProps> = ({
  columns,
  rows,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  isLoading,
  totalRecords,
  onActionClick,
}) => {
  const [openModal,setOpenModal]=useState<boolean>(false);
  const [rowsData,setRowsData]=useState<any>(null);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleViewStatusModal = (row: any) => {
    setOpenModal(true);
    setRowsData(row);
  }
  return (
    <>
      <StyledTableContainer>
      <Table aria-label="sticky table" style={{ width: "100%" }}>
        <TableHead>
        <TableRow>
          {columns?.map((column) => (
          <StyledTableCellHead key={column.id}>
            {column.label || "-"}
          </StyledTableCellHead>
          ))}
        </TableRow>
        </TableHead>
        <TableBody>
        <>
          {rows?.map((row, rowIndex) => (
          <TableRow role="checkbox" tabIndex={-1} key={rowIndex}>
            {columns?.map((column,index) => (
            <StyledTableCellBody key={column.id}>
              {column.id === "status" || column.id === "newStatus" ? (
              <>
                {Array.isArray(row?.lienValues) && row.lienValues.length > 0  && row[column.id] !== "query"?
                <StatusBadge
                  statusColor="#EA5455"
                  backgroundColor="rgba(153, 169, 241, 0.2)"
                  onClick={() => handleViewStatusModal(row)}
                  style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                  <span
                  style={{
                    cursor: "pointer",
                    textDecoration: "underline",
                    color: "blue",
                    textAlign: "center",
                    width: "100%",
                    display: "block"
                  }}
                  >
                  {"View Status"}
                  </span>
                </StatusBadge>
                :
                row[column.id] === "reject" ||
                row[column.id] === "Failed" ? (
                <StatusBadge
                  statusColor="#EA5455"
                  backgroundColor="rgba(234, 84, 85, 0.2)"
                >
                  <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "8px",
                  }}
                  >
                  {row[column.id] === "reject"
                    ? "Rejected"
                    : row["status"] === "LINK_EXPIRED"
                    ? "Link Expired"
                    : "Failed"}
                  {row[column.id] === "reject" && (
                    <Tooltip
                    title={row.remark}
                    enterTouchDelay={50}
                    placement="top"
                    >
                    <img
                      src={InfoIcon}
                      alt="Status"
                      style={{
                      height: "15px",
                      width: "15px",
                      position: "relative",
                      left: "55%",
                      }}
                    />
                    </Tooltip>
                  )}
                  </span>
                </StatusBadge>
                ) : row[column.id] === "indraft" ? (
                <StatusBadge
                  statusColor="#E1DBFD"
                  backgroundColor="rgba(225, 219, 253, 0.2)"
                  style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                  <span
                  style={{
                    color: "#1CB1B1",
                    textTransform: "capitalize",
                    width: "100%",
                    textAlign: "center",
                    display: "block",
                    marginLeft: "8px",
                  }}
                  >
                  {row[column.id]}
                  </span>
                </StatusBadge>
                ) : row[column.id] === "cancelled" ? (
                <StatusBadge
                  statusColor="#EA5455"
                  backgroundColor="rgba(234, 84, 85, 0.2)"
                >
                  <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "8px",
                  }}
                  >
                  {row[column.id]}
                  {row[column.id] === "cancelled" && (
                    <Tooltip
                    title={row.remark}
                    enterTouchDelay={50}
                    placement="top"
                    >
                    <img
                      src={InfoIcon}
                      alt="Status"
                      style={{
                      height: "15px",
                      width: "15px",
                      position: "relative",
                      left: "47%",
                      }}
                    />
                    </Tooltip>
                  )}
                  </span>
                </StatusBadge>
                ) : row[column.id] === "query" ? (
                <StatusBadge
                  statusColor="#E1DBFD"
                  backgroundColor="rgba(225, 219, 253, 0.2)"
                  style={{ display: "flex", justifyContent: "center", alignItems: "center", }}
                >
                  <span
                  style={{
                  color: "#1CB1B1",
                  textTransform: "capitalize",
                  width: "100%",
                  textAlign: "center",
                  display: "block"
                  }}
                  >
                  {row[column.id]}
                  </span>
                </StatusBadge>
                ) : row[column.id] === "approve" ||
                row[column.id] === "Success" ? (
                <StatusBadge
                  statusColor="#28C76F"
                  backgroundColor="rgba(40, 199, 111, 0.2)"
                  style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                  <span
                  style={{
                  width: "100%",
                  textAlign: "center",
                  display: "block",
                  marginLeft: "8px",
                  }}
                  >
                  {row[column.id] === "approve"
                  ? "Approved"
                  : "Success"}
                  </span>
                </StatusBadge>
                ) : row[column.id] === "LINK_EXPIRED" ? (
                <StatusBadge
                  statusColor="#EA5455"
                  backgroundColor="rgba(234, 84, 85, 0.2)"
                >
                  <span
                  style={{
                    color: "#EA5455",
                    textTransform: "capitalize",
                  }}
                  >
                  PendingFromAvanse
                  </span>
                </StatusBadge>
                ) : row[column.id] === "pendingFromAvanse" ? (
                
                 <StatusBadge
                  statusColor="#EA5455"
                  backgroundColor="rgba(234, 84, 85, 0.2)"
                >
                  <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "8px",
                  }}
                  >
                  {"Pending"}
                  {row[column.id] === "pendingFromAvanse" && (
                    <Tooltip
                    title={"Pending From Avanse"}
                    enterTouchDelay={50}
                    placement="top"
                    >
                    <img
                      src={InfoIcon}
                      alt="Status"
                      style={{
                      height: "15px",
                      width: "15px",
                      position: "relative",
                      left: "55%",
                      }}
                    />
                    </Tooltip>
                  )}
                  </span>
                </StatusBadge>
                ) :row[column.id] === "Pending" || row[column.id] === "pending" ? (
                
                 <StatusBadge
                  statusColor="#eaa45eff"
                  backgroundColor="rgba(244, 225, 117, 0.2)"
                >
                  <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "8px",
                  }}
                  >
                  {"Pending"}
                    <Tooltip
                    title={"Pending From Avanse"}
                    enterTouchDelay={50}
                    placement="top"
                    >
                    <img
                      src={InfoIcon}
                      alt="Status"
                      style={{
                      height: "15px",
                      width: "15px",
                      position: "relative",
                      left: "58%",
                      }}
                    />
                    </Tooltip>
                  </span>
                </StatusBadge>
                ) : row[column.id] === "In Progress" ? (
                 <StatusBadge
                  statusColor="#6a6adb"
                  backgroundColor="rgba(59, 80, 245, 0.2)"
                  style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                  <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "8px",
                  }}
                  >
                  {"In Progress"}
                  </span>
                </StatusBadge>
                ): (
                <>
                  <span>{row[column.id]}</span>
                </>
                )}
              </>
              ) : 
              (
              <>
                {column.id === "trancheAmount" ? (
                <>
                  <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                  >
                  {row[column?.id] ? (
                    <span>
                    {row?.currencyCode} {row[column?.id]}
                    {/* {row.status == "approve" && (
                      <Tooltip
                      title={`Disbursement Amount = INR ${row?.disbursedAmount}`}
                      enterTouchDelay={50}
                      placement="top"
                      >
                      <img
                        src={InfoIcon}
                        alt="Status"
                        style={{
                        height: "15px",
                        width: "15px",
                        marginLeft: "5px",
                        position: "relative",
                        top: "4px",
                        }}
                      />
                      </Tooltip>
                    )} */}
                    </span>
                  ) : (
                    "-"
                  )}
                  </span>
                </>
                ) :
                column.id === "disbursedAmount" ? (
                 Array.isArray(row?.lienValues) && row.lienValues.length > 0
                ? row.lienValues
                  .filter((item: any) => item.status === "approved")
                  .reduce((sum: any, item: any) => sum + Number(item.amount), 0)===0
                  ? "NA"
                  : `INR ${row.lienValues
                  .filter((item: any) => item.status === "approved")
                  .reduce((sum: any, item: any) => sum + Number(item.amount), 0)}`
                : "NA"
                ): 
                (
                <>{displayValue(column, row, onActionClick)}</>
                )}
              </>
              )}
            </StyledTableCellBody>
            ))}
          </TableRow>
          ))}
        </>
        </TableBody>
      </Table>
      </StyledTableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 100]}
        component="div"
        count={totalRecords}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        disabled={isLoading}
      />
     <ModalViewAction rows={rowsData} onCloseFun={() => handleCloseModal()} openModal={openModal}/>
    </>
  );
};

export default Tables;
